export default __webpack_public_path__ + "static/media/add-image.1f6076eb.svg";